module.exports = "/images/greaterThanEqual.svg";